import React from 'react';
import PropTypes from 'prop-types';
import ScreenModal from 'chameleon/ui-stack/ui/modals/screen-modal';
import './StudentResponsesModal.scss';

/**
 * Draws student responses
 * */
const StudentResponsesModal = (props) => {
  const { children, modalHeader, onClose } = props;

  return (
    <ScreenModal
      data-test-students-responses-modal
      title={modalHeader}
      onClose={onClose}
    >
      {children}
    </ScreenModal>
  );
};

StudentResponsesModal.displayName = 'StudentResponsesModal';

StudentResponsesModal.propTypes = {
  modalHeader: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default StudentResponsesModal;
